// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 8V3H1V8L23 8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 9.99756H1V21L23 21V9.99756ZM5 18L5 13L7 13L7 18H5Z"}}]};

const TerminalWindowFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'terminal-window-filled',
    ref,
    icon: element,
  },
));

TerminalWindowFilledIcon.displayName = 'TerminalWindowFilledIcon';

export default TerminalWindowFilledIcon;
